module.exports = __webpack_public_path__ + "static/media/bell-green.c945bc2a.png";